var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListedProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listed-product_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.09 99.78"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M9.79 28.27h130.5v65H9.79z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M233.17 12.72h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M198.63 5.35h51.2c.45 0 .82 1.26.82 2.82v14.11c0 1.55-.37 2.82-.82 2.82h-51.2c-.46 0-.83-1.27-.83-2.82V8.17c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M233.17 38.72h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M198.63 31.35h51.2c.45 0 .82 1.26.82 2.82v14.11c0 1.55-.37 2.82-.82 2.82h-51.2c-.46 0-.83-1.27-.83-2.82V34.17c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M293.17 12.72h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M258.63 5.35h51.2c.45 0 .82 1.26.82 2.82v14.11c0 1.55-.37 2.82-.82 2.82h-51.2c-.46 0-.83-1.27-.83-2.82V8.17c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M293.17 38.72h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M258.63 31.35h51.2c.45 0 .82 1.26.82 2.82v14.11c0 1.55-.37 2.82-.82 2.82h-51.2c-.46 0-.83-1.27-.83-2.82V34.17c0-1.56.37-2.82.83-2.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M353.17 12.72h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "listed-product_svg__clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "listed-product_svg__cls-1",
    d: "M353.17 38.72h9l-4.5 5-4.5-5z"
  })), /*#__PURE__*/React.createElement("style", null, ".listed-product_svg__cls-1,.listed-product_svg__cls-2{fill:none}.listed-product_svg__cls-2{stroke:#333;stroke-width:2px}.listed-product_svg__cls-3,.listed-product_svg__cls-6{isolation:isolate}.listed-product_svg__cls-6{font-size:14px;font-family:FontAwesome5Free-Solid,&quot;Font Awesome 5 Free&quot;;fill:#0e5a7b}"))), /*#__PURE__*/React.createElement("g", {
    id: "listed-product_svg__Group_68048",
    "data-name": "Group 68048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "listed-product_svg__Group_68044",
    "data-name": "Group 68044"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "listed-product_svg__Line_253",
    "data-name": "Line 253",
    className: "listed-product_svg__cls-2",
    d: "M9.79 13.77h99"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(126.29 19.27)",
    style: {
      isolation: "isolate"
    },
    fill: "#a3cb63",
    fontSize: 14,
    fontFamily: "FontAwesome5Free-Solid,\"Font Awesome 5 Free\"",
    id: "listed-product_svg___"
  }, "\uF00C")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#listed-product_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "listed-product_svg__Repeat_Grid_2",
    "data-name": "Repeat Grid 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "listed-product_svg__Group_68045",
    "data-name": "Group 68045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "listed-product_svg__Line_253-2",
    "data-name": "Line 253-2",
    className: "listed-product_svg__cls-2",
    d: "M9.79 36.77h99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "listed-product_svg___2",
    "data-name": 2,
    className: "listed-product_svg__cls-3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "listed-product_svg__cls-6",
    transform: "translate(126.29 41.27)"
  }, "\uF055"))), /*#__PURE__*/React.createElement("g", {
    id: "listed-product_svg__Group_68045-2",
    "data-name": "Group 68045-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "listed-product_svg__Line_253-3",
    "data-name": "Line 253-3",
    className: "listed-product_svg__cls-2",
    d: "M9.79 61.77h99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "listed-product_svg___3",
    "data-name": 3,
    className: "listed-product_svg__cls-3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "listed-product_svg__cls-6",
    transform: "translate(126.29 66.27)"
  }, "\uF055"))), /*#__PURE__*/React.createElement("g", {
    id: "listed-product_svg__Group_68045-3",
    "data-name": "Group 68045-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "listed-product_svg__Line_253-4",
    "data-name": "Line 253-4",
    className: "listed-product_svg__cls-2",
    d: "M9.79 86.77h99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "listed-product_svg___4",
    "data-name": 4,
    className: "listed-product_svg__cls-3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "listed-product_svg__cls-6",
    transform: "translate(126.29 91.27)"
  }, "\uF055"))))))));
}
export default SvgListedProduct;